
var id = "update";
var markup = "<symbol viewBox=\"0 0 22 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"update\">\n    <title>icon/action/cached_24px</title>\n    <defs>\n        <path d=\"M19,8 L15,12 L18,12 C18,15.31 15.31,18 12,18 C10.99,18 10.03,17.75 9.2,17.3 L7.74,18.76 C8.97,19.54 10.43,20 12,20 C16.42,20 20,16.42 20,12 L23,12 L19,8 Z M6,12 C6,8.69 8.69,6 12,6 C13.01,6 13.97,6.25 14.8,6.7 L16.26,5.24 C15.03,4.46 13.57,4 12,4 C7.58,4 4,7.58 4,12 L1,12 L5,16 L9,12 L6,12 Z\" id=\"update_path-1\" />\n    </defs>\n    <g id=\"update_Material-Icons-(filled)\" stroke=\"none\" stroke-width=\"1\" fill=\"\" fill-rule=\"evenodd\">\n        <g id=\"update_34.-Icons/filled/action/cached_24px\" transform=\"translate(-1.000000, -4.000000)\">\n            <mask id=\"update_mask-2\" fill=\"white\">\n                <use xlink:href=\"#update_path-1\" />\n            </mask>\n            <use id=\"update_icon/action/cached_24px\" fill-opacity=\"0.87\" fill=\"\" xlink:href=\"#update_path-1\" />\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
